import { render, staticRenderFns } from "./ModalEntregues.vue?vue&type=template&id=6a5a859f&scoped=true&"
import script from "./ModalEntregues.vue?vue&type=script&lang=js&"
export * from "./ModalEntregues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a859f",
  null
  
)

export default component.exports